import ManageStockTransactionForm from '@/PageComponents/StockTransaction/ManageStockTransactionForm';
import { StockTransaction } from '@/interfaces/api/models';
import stockTransactionService from '@/services/stock-transaction/stock-transaction-service';
import { FC } from 'react';
import * as Enums from '@/utils/enums';
import Breadcrumbs from '@/components/breadcrumbs';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { createFileRoute } from '@tanstack/react-router'

const StockTransactionPage: FC = () => {

    const router = useRouter();
    const { id } = router.query as { id: string }; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const { data: stockTransaction, isLoading } = useQuery(
        ['stockTransaction', id],
        () => stockTransactionService.getStockTransaction(id),
        { enabled: !!id }
    );

    if (isLoading || !stockTransaction) return <div>Loading...</div>;

    return (<>

        <div className="manage-container">

            <div className="row">
                <div className="title">
                    <Breadcrumbs currPage={{ text: stockTransaction.StockTransactionNumber, link: `/stocktransaction/${stockTransaction.ID}`, type: 'edit' }} />
                </div>
            </div>

            <ManageStockTransactionForm
                isNew={false}
                stockTransactionType={stockTransaction.StockTransactionType ?? 0}
                stockTransaction={stockTransaction}
            />
        </div>

        <style jsx>{`
            
        `}</style>
    </>);
};

export default StockTransactionPage;

export const Route = createFileRoute('/_authenticated/stocktransaction/$id')({ component: StockTransactionPage })
